// core/base/master-service.ts
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class MasterService<T> {
    private allowedModules: string[] = [];
    private userRole: string = '';
    public userName:string = '';
    public userEmail: string = ''
    public isSystemUser: boolean = false;

    constructor(protected http: HttpClient, protected baseUrl: string) {
        const token = localStorage.getItem('authToken');
        if (token) {
            const payload = JSON.parse(atob(token.split('.')[1]));
            this.allowedModules = payload.modules || [];
            this.userRole = payload.roles?.[0]?.name || '';
            this.userName = `${payload.firstName || ''} ${payload.lastName || ''}`
            this.userEmail = payload.email
            this.isSystemUser = payload.isSystemUser || false;
        }
    }

    getAll(): Observable<T[]> {
        return this.http.get<T[]>(this.baseUrl);
    }

    getById(id: number): Observable<T> {
        return this.http.get<T>(`${this.baseUrl}/${id}`);
    }

    save(data: T): Observable<T> {
        return this.http.post<T>(this.baseUrl, data);
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    hasModuleAccess(moduleName: string): boolean {
        return this.allowedModules.includes(moduleName);
    }

    getUserRole(): string {
        return this.userRole;
    }

}
